export default {"src":"/_next/static/image/public/images/icons2/5.4352b2c36bd850af58fb4683096eb111.svg","height":24,"width":24};